<script>
export default {
  name: 'Redirect',
  beforeCreate() {
    const p = this.$route.query.p || '/'
    this.$router.replace(p)
  },
  render: (h) => h(),
}
</script>
